// src/components/Assets/Templates/Normal1/normal1.js
export default `
  <!doctype html>
<html ⚡4email data-css-strict>
<head>
<meta charset="utf-8">
<script async src="https://cdn.ampproject.org/v0.js"></script>
<script async custom-element="amp-bind" src="https://cdn.ampproject.org/v0/amp-bind-0.1.js"></script>
<script async custom-element="amp-form" src="https://cdn.ampproject.org/v0/amp-form-0.1.js"></script>


<style amp4email-boilerplate>
body
{visibility:hidden}
</style>
<style amp-custom >

@media only screen and (max-width: 480px) {

.w100{width:100% ;}

}
@media only screen and (max-width: 580px) {
.w100{width:100% ;}

}

</style>

</head>
<body >
<table width="100%" bgcolor="#f3f3f3">
<tbody>
<tr>
<td>
<table  width="600" align="center" class="w100">
<tbody>
<tr>
<td>
<table width="100%" align="center" bgcolor="#b6aee1">
<tbody>
<tr><td class="darkmode" style="padding: 20px 0px; font-size: 26px; line-height: 30px; font-family: Arial, Helvetica, sans-serif; text-align: center; font-weight: bold; background-color: #352685; color: #ffffff;">Srihari Muppalla</td></tr>
<tr>
<td height="20"></td>
</tr>
<tr>
<td align="center">
<table width="70%" align="center" bgcolor="#352685"  [hidden]="recommender.currentStep != 0">
<tbody>
<tr>
<td>
<div>
<div style="display: flex; flex-direction: row; justify-content: center; margin: 0px 0px 20px 0px;" >
<tr>
<td align="center" style="color:#ffffff;text-align:center;background-color: #352685;text-align: center;font-size: 24px;font-weight: bold;line-height: 28px;padding: 10px 10px;">
Registration Form
</td>
</tr>
<tr>
<td align="center" >
<form method="post" action-xhr="https://example.com/subscribe" >
<input type="text"  placeholder="First Name" pattern="[A-Za-z]{1,20}"  style="width: 250px;height:40px;text-align: left;border-radius: 10px;padding-left: 10px;" required>
<br><br>
<input type="text"  placeholder="Last Name" pattern="[A-Za-z]{1,20}" style="width: 250px;height:40px;text-align: left;border-radius: 10px;padding-left: 10px; " required>
<br><br>
<input type="number"  placeholder="Please Enter Mobile Number" pattern="[789][0-9]{9}" style="width: 250px;height:40px;text-align: left;border-radius: 10px;padding-left: 10px;" required>
<br><br>
<input type="email"  placeholder="Please Enter Email ID" style="width: 250px;height:40px;text-align: left;border-radius: 10px;padding-left: 10px;" required>
<br><br>
<input type="pw"  placeholder="Please Enter Password" style="width: 250px;height:40px;text-align: left;border-radius: 10px;padding-left: 10px;" required><br><br>
<table >
<tbody>
<tr>
<td style="color:#ffffff;text-align:center;background-color: #352685;text-align: left;font-size: 16px;font-weight: bold;line-height: 20px;width: 250px;">
<p style="color:#ffffff;text-align:left;background-color: #352685;text-align: left;font-size: 16px;font-weight: bold;line-height: 18px;"> Gender:</p>
<p> MALE <input type="radio" required id="male" name="fav_language" value="MALE">
FEMALE<input type="radio" required id="female" name="fav_language" value="FEMALE"></p>
</td>
</tr>
<tr>
<td style="color:#ffffff;text-align:center;background-color: #352685;text-align: left;font-size: 14px;font-weight: bold;line-height: 20px;width: 250px;">
<input type="checkbox">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
</td>
</tr>
<tr>
<td style="color:#ffffff;text-align:center;background-color: #352685;text-align: left;font-size: 14px;font-weight: bold;line-height: 20px;width: 250px;padding-bottom: 10px;">
<input type="checkbox" >Lorem Ipsum is simply dummy text of the printing and typesetting industry.
</td>
</tr>
</tbody>
</table>
<button type="submit" class="user-valid valid"   name="send" style=" width: 245px;
height: 49px;
background-color: transparent;                                                                                
border: 0px;
cursor: pointer; " role="" tabindex=""  on="tap:AMP.setState({recommender: {currentStep: recommender.currentStep + 1}})"><amp-img src="https://ik.imagekit.io/sriHari143/templates/amp/Submit_2V8sxjRRI.png?updatedAt=1742543653708" alt="Submit" width="245" height="49"></amp-img></button> 
<!-- <input type="submit" value="Submit" style="width: 100px;height:35px;text-align: center;border-radius: 10px;border: none;background-color: #0ea45f;color: #ffffff;font-size: 18px;font-weight: bold;"><br><br> -->
</form>
</td>
</tr>
</div>
</div>
</td>
</tr>
<tr>
<td height="20"></td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr><td  hidden="" [hidden]="recommender.currentStep != 1">
<div style="display: flex; flex-direction: row; justify-content: center; margin: 20px 20px 20px 20px;">
<div style="width: 50%">
<p style="margin: 0px 0px 0px 0px; ">Registration Completed Seccessfully</p> <br>
</div>
<div style="width: 50%" align="right"><div style="width: 150px; height: 25px; background-color: #69BF1A; color: #000000;text-align: center; padding-top: 10px; border-radius: 10px;" role="" tabindex="" on="tap:AMP.setState({recommender: {currentStep: recommender.currentStep - 1}})">Thank You</div></div>
</div>
</td></tr>
<tr>
    <td height="20"></td>
</tr>
<tr>
    <td bgcolor="#352685" style="text-align: center; font-size:18px; padding: 10px 0px; font-family:Lato,Arial,sans-serif; line-height:21px; height: 25px; color: #ffffff;" > Srihari Muppalla </td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</body>
</html>
`;